<template>
	<div>
		<buttonlist @help="help" @exps="exps" ref="SetBtn"></buttonlist>
		<table>
			<tr>
				<td>{{ $t('getapi[4057]') }}</td>
				<td>
					<el-date-picker v-model="edata" size="mini" type="date"></el-date-picker>
				</td>
				<td>{{ $t('getapi[112]') }}</td>
				<td>
					<el-input v-model="partcode" type="text" placeholder="支持模糊查询" size="mini"></el-input>
				</td>
				<td>
					<el-button type="primary" size="mini" @click="getView" :loading="loading" :disabled="loading">
						{{ $t('getapi[1980]') }}
					</el-button>
				</td>
			</tr>
		</table>
			<el-table
				id="xpane-0"
				:data="dataSet"
				v-loading="loading"
				:highlight-current-row="true"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				:height="tableHeight"
				header-row-class-name="headerclass"
				style="width: 100%; margin-top:0px"
				ref="singleTable"
			>
				<el-table-column type="selection" v-if="false"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="100"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"  width="100"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"  width="150"></el-table-column>
				<el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"  width="100"></el-table-column>
				<el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"  width="100"></el-table-column>
				<el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1882]')"  width="100"></el-table-column>
				<el-table-column prop="onhand" align="right" :label="$t('getapi[13138]')"  width="100"></el-table-column>
				<el-table-column prop="ondayhand" align="right" :label="$t('getapi[13139]')"  width="100"></el-table-column>
				
			</el-table>
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'DailyInventory',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3  - Common.reduceTableHeight2
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('DailyInventory'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            scrollTop:0,
            edata:'',
			partcode:'',
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[13138]"),this.$t("getapi[15]"));
        },
		// 导出
		exps() {
			let that = this;
			let parm = {
                "endtime": that.edata,
				"partcode":that.partcode,
			}
			that.$http.urlpost('/Inv/Manager/DailyInventoryDataNewExportExcel', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
		},
		handleSizeChange(val) {
			this.pageSize = val;			
			this.$http.savePageSize('DailyInventory',val);
			this.getView();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
		},
		authority() {
			let that = this;
            // that.$refs.SetBtn.SetButtonEnable('');
            // if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
            //     that.$refs.SetBtn.SetOneBtnEnable('help,exps',true);
			// 	that.$refs.SetBtn.SetOneBtnEnable('help,',true);
            // }
			that.$refs.SetBtn.SetButtonEnable('help,export');
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let parm = {
                "endtime": that.edata,	
				"partcode":that.partcode,			
				"PageIndex": that.pageIndex,
				"PageSize": that.pageSize,
			}
			that.$http.urlpost('/Inv/Manager/Get_DailyInventoryData_New', parm, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = (
				new Date().getFullYear() +
				'-' +
				(new Date().getMonth() + 1) +
				'-' +
				new Date().getDate() +
				' ' +
				new Date().getHours() +
				':' +
				new Date().getMinutes() +
				':' +
				new Date().getSeconds()
			).toString();
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
